import { createReducer } from "@reduxjs/toolkit";
import { IfIsaState } from "./ifIsa.types";
import { signInAsync, signOutAsync } from "../auth/auth.actions";
import {
  fetchIfIsaAccountAPI,
  fetchIfIsaTransfersAPI,
  fetchIfIsaYearlyContributionAPI,
} from "./ifIsa.actions";

export const INITIAL_STATE: IfIsaState = {
  account: {
    neverLoaded: true,
    loading: false,
    data: null,
    error: null,
  },
  yearlyContribution: {
    neverLoaded: true,
    loading: false,
    data: null,
    error: null,
  },
  transfers: {
    neverLoaded: true,
    loading: false,
    data: [],
    error: null,
  },
};

const ifIsaReducer = createReducer(INITIAL_STATE, (builder) => {
  builder
    // Reset state on auth state changes
    .addCase(signInAsync.fulfilled, () => INITIAL_STATE)
    .addCase(signOutAsync.fulfilled, () => INITIAL_STATE)

    // Account actions
    .addCase(fetchIfIsaAccountAPI.pending, (state) => {
      state.account.loading = true;
      state.account.error = null;
    })
    .addCase(fetchIfIsaAccountAPI.fulfilled, (state, action) => {
      state.account.neverLoaded = false;
      state.account.loading = false;
      state.account.data = action.payload;
      state.account.error = null;
    })
    .addCase(fetchIfIsaAccountAPI.rejected, (state) => {
      state.account.loading = false;
      state.account.error = "Failed to fetch IF-ISA account";
    })

    // Yearly contribution actions
    .addCase(fetchIfIsaYearlyContributionAPI.pending, (state) => {
      state.yearlyContribution.loading = true;
      state.yearlyContribution.error = null;
    })
    .addCase(fetchIfIsaYearlyContributionAPI.fulfilled, (state, action) => {
      state.yearlyContribution.neverLoaded = false;
      state.yearlyContribution.loading = false;
      state.yearlyContribution.data = action.payload;
      state.yearlyContribution.error = null;
    })
    .addCase(fetchIfIsaYearlyContributionAPI.rejected, (state) => {
      state.yearlyContribution.loading = false;
      state.yearlyContribution.error =
        "Failed to fetch IF-ISA yearly contribution";
    })

    // Transfers actions
    .addCase(fetchIfIsaTransfersAPI.pending, (state) => {
      state.transfers.loading = true;
      state.transfers.error = null;
    })
    .addCase(fetchIfIsaTransfersAPI.fulfilled, (state, action) => {
      state.transfers.neverLoaded = false;
      state.transfers.loading = false;
      state.transfers.data = action.payload;
      state.transfers.error = null;
    })
    .addCase(fetchIfIsaTransfersAPI.rejected, (state) => {
      state.transfers.loading = false;
      state.transfers.error = "Failed to fetch IF-ISA transfers";
    });
});

export default ifIsaReducer;
